import stateApi from '@/api/stateApi';
import CollectionDetails from '@/components/collectionDetails';
import InspectTabs from '@/components/inspectTabs';
import { InspectTabsSearchParams } from '@/lib/inspectLocation';
import { addRecentEntity } from '@/lib/recentEntities';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/inspect/$db/$coll')({
  component: RouteComponent,
  validateSearch: InspectTabsSearchParams,
});

function RouteComponent() {
  const { db, coll } = Route.useParams();
  const id = [db, coll].join('/');

  const collection = stateApi.mergedCollections.useStore((dbs) => {
    return dbs.find((x) => x.db === db)?.collections.find((x) => x.coll === coll);
  });

  useEffect(() => {
    if (id) {
      addRecentEntity(id);
    }
  }, [id]);

  return <InspectTabs key={id} db={db} coll={coll} header={collection && <CollectionDetails coll={collection} />} />;
}
